module.exports = __webpack_public_path__ + "static/media/presense-logo-with-BG-negative.887e7053.png";